import {useMemo} from 'react'

import {filterThreads} from './utils/filter-items'

import {useDiffPathOrderMap, useThreads} from '../../stores/layout-selectors'
import {sortThreadsByDate, sortThreadsByDiffOrder} from './utils/sort-items'
import type {UseFilteredCommentsDataOptions} from './use-filtered-conversation-comments'

/** Fetch and calculate filtered review thread items. */
export function useFilteredReviewThreads({filterState, sort}: UseFilteredCommentsDataOptions) {
  const threadPreviews = useThreads()

  const diffPathOrderMap = useDiffPathOrderMap()

  // Review thread mode displays threads as flat list without issue comments or review summaries
  const filteredThreads = useMemo(() => {
    const filteredItems = filterThreads(threadPreviews, filterState)
    const filteredSortedItems =
      sort === 'diff-order'
        ? sortThreadsByDiffOrder(filteredItems, diffPathOrderMap)
        : sortThreadsByDate(filteredItems, sort)

    return filteredSortedItems
  }, [filterState, threadPreviews, diffPathOrderMap, sort])

  return {
    /** Thread items matching the conversation filter and sort direction. */
    filteredThreads,
    /** Total number of threads in this PR. */
    totalThreadsCount: threadPreviews.length,
  }
}
